import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 7, viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.97168 1L6.20532 6L11.439 1", stroke: "#AEAEAE" }));
const ForwardRef = forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
